import React, { FC } from 'react'
import { Box, Skeleton } from 'transfix-ui/core'

export interface IInsightsCardChartBlockProps {
  withContentPadding?: boolean
  isLoading?: boolean
}

const CARD_PADDING_PX = 3

export const InsightsCardChartBlock: FC<IInsightsCardChartBlockProps> = props => {
  const { children, isLoading = true, withContentPadding } = props
  return isLoading ? (
    <Box px={CARD_PADDING_PX} pb={CARD_PADDING_PX}>
      <Skeleton width='100%' height={88} animation='wave' />
      <Skeleton width={73} height={15} animation='wave' />
    </Box>
  ) : (
    <Box px={withContentPadding ? 3 : 0} pb={withContentPadding ? 3 : 0}>
      {children}
    </Box>
  )
}
